<fieldset class="flex flex-col gap-1 border-0 p-0">
  @if (inputLabel()) {
    <legend
      [style.marginBottom]="'var(--measurementinput-legend-margin-bottom)'"
      [style.fontSize]="'var(--measurementinput-legend-font-size)'"
      [style.fontWeight]="'var(--measurementinput-legend-font-weight)'"
      [style.lineHeight]="'var(--measurementinput-legend-line-height)'"
    >
      {{ inputLabel() }}
    </legend>
  }
  <div
    [class]="containerClass()"
    [style.gap]="containerStyle().gap"
    [style.padding-left]="containerStyle().paddingLeft"
    [style.padding-right]="containerStyle().paddingRight"
    [style.padding-top]="containerStyle().paddingTop"
    [style.padding-bottom]="containerStyle().paddingBottom"
    [style.border-radius]="containerStyle().borderRadius"
    [style.font-family]="containerStyle().fontFamily"
    [style.background]="containerStyle().background"
    [style.border-width]="containerStyle().borderWidth"
    [style.border-color]="containerStyle().borderColor"
    [style.border-style]="containerStyle().borderStyle"
  >
    <input
      type="number"
      [attr.aria-label]="config().ariaLabel ?? ('common.weightInputAriaLabel' | translate)"
      class="weight-input w-auto min-w-16 max-w-32 bg-transparent border-none outline-none text-center font-semibold text-5xl leading-[1.2] tracking-[-2.4px] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
      [style.color]="'var(--measurementinput-' + currentState() + '-value-color)'"
      [style.--placeholder-color]="placeholderColor()"
      [formControl]="$any(control)"
      [placeholder]="config().placeholder?.toString() ?? '225'"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="enforceMaxLength($event, 3)"
    />
    <span
      class="font-semibold text-xl leading-[1.3] tracking-[-0.4px]"
      [style.color]="'var(--measurementinput-' + currentState() + '-unit-color)'"
    >
      lbs
    </span>
  </div>
  @if (invalid) {
    <lib-field-error [control]="control!"></lib-field-error>
  }
</fieldset>
